import {Box,CheckboxGroup,Checkbox,Stack,useToast,Text, Input, Spacer, Accordion, AccordionItem,AccordionPanel,AccordionButton,
     AccordionIcon, ButtonGroup, Button, Tag, TagLabel,TagCloseButton} from '@chakra-ui/react'
import { useEffect,useState } from 'react'
import { getKnjigeLokacije } from '../../util/apiKnjiga';
import { getDrzaveUvoza } from '../../util/apiDrzava';
import { MdFilterAlt,MdCancel, MdPerson} from 'react-icons/md';
import OsobeSelect from '../osoba/OsobaSelect';


export default function DolasciFilter({onSetFilter, onClose, size='xs'}) {
    const [knjige,setKnjige]=useState({});
    const [drzaveuvoza, setDrzaveUvoza]=useState([]);
    const [lokacije,setLokacije]=useState([]);
    const [filter,setFilter]=useState({posjednikSelect:false,posjednici:[],knjige:[],dolazaktipovi:[],datumod:(new Date().getFullYear()-1).toString()+'-01-01',
        datumdo:new Date().toISOString().split("T")[0],drzave:[]})
    const toast=useToast();
    
    useEffect(() => {
        const fetchKnjige=async ()=>{
        try {
            const res=await getKnjigeLokacije();
            if (res.status===200) {
                setKnjige(res.res)
                let _oldlok="";
                const _lok=[];
                res.res.forEach((knjiga)=>{
                    if (knjiga.lokacija!==_oldlok) {
                        _lok.push(knjiga.lokacija)
                        _oldlok=knjiga.lokacija
                    }
                        
                    
                })
                setLokacije(_lok);
            } else {
                throw new Error(res.message);
            }
        } catch (error) {
            toast({
                title:"Greška kod dohvata podataka.",
                status:"error",
                description:error.message,
                isClosable:true,
                duration:2000,
                position:"top-right",
            });
        }
    }
    const fetchDrzaveUvoza=async ()=>{
        try {
            const res=await getDrzaveUvoza();
            if (res.status===200) {
                setDrzaveUvoza(res.res)
            } else {
                throw new Error(res.message);
            }
        } catch (error) {
            toast({
                title:"Greška kod dohvata podataka.",
                status:"error",
                description:error.message,
                isClosable:true,
                duration:2000,
                position:"top-right",
            });
        }
    }
      fetchKnjige();
      fetchDrzaveUvoza();
    }, [toast])
    
    const onCheckKnjiga=(event)=>{
        const _knjid=event.target.value;
        const _add=event.target.checked;
        const _knjige=filter.knjige;
        const idx=_knjige.findIndex(knjigaid=>Number(knjigaid)===Number(_knjid));
        
        if (_add && idx===-1) {//dodaje se knjiga te ista ne postoji u state-u
            _knjige.push(_knjid);
       } else if (!_add && idx!==-1) {//odchekirana je knjiga te ju treba maknuti iz state-a
            _knjige.splice(idx,1);
        }
        setFilter({...filter,knjige:_knjige})
    }
    /*const onCheckLokacija=(event)=>{
        const _lokacija=event.target.value;
        const _add=event.target.checked;
        const _knjigelokacija=knjige.filter((knj)=>{return knj.lokacija===_lokacija});
        const _newknj=filter.knjige;
        let _i=0;
        if (_add) {//dodavanje svih
            _knjigelokacija.forEach((k1)=>{
                if (_newknj.findIndex((k2)=>{return Number(k2)===k1.knjiga_id})===-1) {
                    _newknj.push(k1.knjiga_id);
                }
            })
            
        } else { //makivanje svih knjiga
            _knjigelokacija.forEach((k1)=>{
                _i=_newknj.findIndex((k2)=>{return Number(k2)===k1.knjiga_id});
                if (_i!==-1) {
                    _newknj.splice(_i,1);
                }
            })
        }
        setFilter({...filter,knjige:_newknj});
    }
*/
    /*const chekiraneSveKnjigeLokacije=(lokacija)=>{
        //prvo sve knjige lokacije
        const _knjigelokacija=knjige.filter((knj)=>{return knj.lokacija===lokacija});
        //za sve knjige pronađi jel su zapisane u filter.knjige
        let _b=true;
        let _i=0;
        _knjigelokacija.forEach((k1)=>{
            _i=filter.knjige.findIndex((k2)=>{return Number(k2)===k1.knjiga_id});
            if (_i===-1) {
                _b=false;
            }
        })
        return _b;
    }
*/
    /*const chekiraneNekeKnjigeLokacije=(lokacija)=>{ 
        //prvo sve knjige lokacije
        const _knjigelokacija=knjige.filter((knj)=>{return knj.lokacija===lokacija});
        //za sve knjige pronađi jel su zapisane u filter.knjige
        let _b=true;
        let _i=0;
        let _brojac=0;
        _knjigelokacija.forEach((k1)=>{
            _i=filter.knjige.findIndex((k2)=>{return Number(k2)===k1.knjiga_id});
            if (_i===-1) {
                _b=false;
            } else {
                _brojac=+1;
            }
        })
        if (_brojac>0 && _b===false) {
            return true;
        } else {
            return false;
        }
    }
*/
    const isKnjigaChecked=(_knjigaid)=>{
        let _r=true;
        const _i=filter.knjige.findIndex((k)=>{return Number(k)===Number(_knjigaid)});
        if (_i===-1) {
            _r=false;
        }
        return _r;
    }
   
    const showKnjige=()=>{
        
        if (JSON.stringify(knjige)!=="{}") {
            return (
                <Stack direction={['column','row']}>
                        {lokacije.map((lokacija,i)=>{
                            return(
                                
                                    <Box ml={'0.5rem'} mr={'0.5rem'}>
                                        
                                        <Box>
                                            <Stack direction={'column'} mb={'0.5rem'} pl={'1rem'}> 
                                                    {knjige.map((knjiga,i)=>{
                                                        if (knjiga.lokacija===lokacija) {
                                                            return (<Checkbox key={`knj${i}`} colorScheme='grunt2' size={'sm'} w={'auto'} isChecked={isKnjigaChecked(knjiga.knjiga_id)} value={knjiga.knjiga_id.toString()} onChange={onCheckKnjiga}>{knjiga.knjiga}</Checkbox>)
                                                        } else {
                                                            return null;
                                                        }
                                                    })}
                                            </Stack> 
                                        </Box>
                                    </Box>
                                
                            )

                        })}
                    {/* </CheckboxGroup> */}
                    </Stack>
            )            
        }
    }

    const onCheckDolazakTip=(event)=>{
        const _doltipsifra=event.target.value;
        const _add=event.target.checked;
        const _dolazaktipovi=filter.dolazaktipovi;
        const idx=_dolazaktipovi.findIndex(sifra=>sifra===_doltipsifra);
        
        if (_add && idx===-1) {//dodaje se tipdolaska te isti ne postoji u state-u
            _dolazaktipovi.push(_doltipsifra);
       } else if (!_add && idx!==-1) {//odchekirana je knjiga te ju treba maknuti iz state-a
            _dolazaktipovi.splice(idx,1);
        }
        setFilter({...filter,dolazaktipovi:_dolazaktipovi})
    }
    

    const showDolazakTipove=()=>{
        return (
            <Box w={'100%'}>
                <Box display={'flex'} flexDir={'row'} w='100%' m='0.5rem'>
                    <CheckboxGroup size={'sm'} colorScheme='grunt2'>
                        <Stack spacing={[15]} direction={['column', 'row']} mb={'0.5rem'}>
                            <Checkbox value={'DKUP'} onChange={onCheckDolazakTip}>Kupnja</Checkbox>        
                            <Checkbox value={'DUVOZ'} onChange={onCheckDolazakTip}>Uvoz</Checkbox>        
                            <Checkbox value={'DTELJ'} onChange={onCheckDolazakTip}>Teljenje</Checkbox>        
                        </Stack>
                    </CheckboxGroup>
                </Box>
                            

                </Box>
        )
    }

    const changeDatum=(event)=>{
        if (event.target.id==="idDatOd") {
            setFilter({...filter,datumod:event.target.value})
        } else if (event.target.id==="idDatDo") {
            setFilter({...filter,datumdo:event.target.value})
        }
    }

    const showDatumi=()=>{
        return (
            <Box w={'100%'}>
                <Box display={'flex'} flexDir={'row'} w='100%' m='0.5rem'>
                    <Box w='49%'>
                        <Text size={size}>Od datuma:</Text>
                        <Input focusBorderColor='grunt2.400' id="idDatOd" size={size}  type="date" variant={'filled'} value={filter.datumod} onChange={changeDatum}/>
                    </Box>
                    <Spacer/>
                    <Box w='49%'>
                        <Text size={size}>Do datuma:</Text>
                        <Input focusBorderColor='grunt2.400' id="idDatDo" size={size}  type="date" variant={'filled'} value={filter.datumdo}  onChange={changeDatum}/>
                    </Box>
                </Box>
                            

             </Box>
        )
    }

const posjednikSelect=(posjednik)=>{
    const _parr=filter.posjednici;
    const contains=_parr.filter(p=>p.id===posjednik.id).length===1;
    if (!contains) {
        const p={id:posjednik.id,naziv:posjednik.naziv,sifra:posjednik.sifra};
        _parr.push(p);
    }
    setFilter({...filter,posjednici:_parr,posjednikSelect:false});  
}

const removeSelectedPosjednik=(posjednikid)=>{
    const _p=filter.posjednici;
    const idx=_p.findIndex(pos=>pos.id===posjednikid);
    _p.splice(idx,1);
    setFilter({...filter,posjednici:_p})
}


const showPosjednici=()=>{
    if (filter.posjednikSelect) {
        return (
        <Box w={'100%'}>
            {/* <OsobaSelect naslov="Posjednici" onClose={(e)=>setState({...state,showpos:false})} onSelect={(osoba)=>setPosjednik(osoba)}/>             */}
            <OsobeSelect naslov="Odlazni posjednik" onSelect={posjednikSelect} onClose={()=>{setFilter({...filter,posjednikSelect:false})}}/>
         </Box>
        )        
    } else {
        return (
            <Box w={'100%'} display={'flex'} flexDir={'column'}>
                <Box>
                <Button rightIcon={<MdPerson/>} colorScheme={'grunt2'} variant={'outline'} size={size} mb={'0.5rem'} onClick={(e)=>setFilter({...filter,posjednikSelect:true})}>Posjednik</Button>
                </Box>
                
                <Box display={'block'}width={'100%'} overflowY={'initial'}>
                
                    {
                        filter.posjednici.map((pos,i)=>{
                            return (
                                <Tag size={'sm'} key={i} borderRadius={'full'} variant={'solid'} colorScheme={'grunt2'} m={'0.1rem'}>
                                    <TagLabel size={'xs'}>{pos.naziv}</TagLabel>
                                    <TagCloseButton size={size} onClick={()=>removeSelectedPosjednik(pos.id)}/>
                                </Tag>
                            )
                        })
                    }
                
                </Box>
            </Box>
        )
    }
    

}

const onCheckDrzava=(event)=>{
    const _drzid=event.target.value;
    const _add=event.target.checked;
    const _drzave=filter.drzave;
    const idx=_drzave.findIndex(id=>id===_drzid);
    
    if (_add && idx===-1) {//dodaje se tipdolaska te isti ne postoji u state-u
        _drzave.push(_drzid);
   } else if (!_add && idx!==-1) {//odchekirana je knjiga te ju treba maknuti iz state-a
        _drzave.splice(idx,1);
    }
    setFilter({...filter,drzave:_drzave})
}

const showDrzaveUvoza=()=>{
    return (
        <Box w={'100%'}>
            <Box display={'block'} w='100%' overflowY={'initial'}>
                <CheckboxGroup colorScheme='grunt2' size={'sm'}>
                    {
                        drzaveuvoza.map((drzava,i)=>{
                            return (<Box mr='0.5rem' display={'inline'}><Checkbox key={`drz${i}`} value={drzava.id.toString()} onChange={onCheckDrzava}>{drzava.naziv}</Checkbox></Box>)
                        })
                    }
                    
                </CheckboxGroup>
            </Box>
                        

            </Box>
    )

}

const onApplyFilter=()=>{
    onSetFilter(filter);
    //let _pos=[];
    /*filter.posjednici.map((posjednik,i)=>{
        _pos.push(posjednik.id);
    })*/
   const _pos = filter.posjednici.map(posjednik => posjednik.id);
    onSetFilter({datumod:filter.datumod,datumdo:filter.datumdo,knjige:filter.knjige,dolazaktipovi:filter.dolazaktipovi,
    odlazniposjednici:_pos,drzave:filter.drzave});
}

  return (
    <Box>
    <Box w={'100%'} h='85vh' overflowY={'auto'}>

        <Accordion allowToggle>
            <AccordionItem>
                
                    <AccordionButton>
                        <Box as="span" flex='1' textAlign='left'>
                            Knjige
                        </Box>
                        <AccordionIcon />
                </AccordionButton>
                
                <AccordionPanel pb={4}>
                    {showKnjige()}
                </AccordionPanel>
            </AccordionItem>
            <AccordionItem>
                <h2>
                    <AccordionButton>
                        <Box as="span" flex='1' textAlign='left'>
                            Tipovi dolazaka
                        </Box>
                        <AccordionIcon />
                </AccordionButton>
                </h2>
                <AccordionPanel pb={4}>
                    {showDolazakTipove()}
                </AccordionPanel>
            </AccordionItem>
            <AccordionItem>
                {/* <h2> */}
                    <AccordionButton>
                        <Box as="span" flex='1' textAlign='left'>
                            Datumi migracija
                        </Box>
                        <AccordionIcon />
                </AccordionButton>
                {/* </h2> */}
                <AccordionPanel pb={4}>
                    {showDatumi()}
                </AccordionPanel>
            </AccordionItem>
            <AccordionItem>
                <h2>
                    <AccordionButton>
                        <Box as="span" flex='1' textAlign='left'>
                            Prijašnji posjednici
                        </Box>
                        <AccordionIcon />
                </AccordionButton>
                </h2>
                <AccordionPanel pb={4}>
                    {showPosjednici()}
                </AccordionPanel>
            </AccordionItem>
            <AccordionItem>
                <h2>
                    <AccordionButton>
                        <Box as="span" flex='1' textAlign='left'>
                            Uvoz
                        </Box>
                        <AccordionIcon />
                </AccordionButton>
                </h2>
                <AccordionPanel pb={4}>
                    {showDrzaveUvoza()}
                </AccordionPanel>
            </AccordionItem>
        </Accordion>
        
    </Box>
    <ButtonGroup gap={'2rem'} mt={'0.5rem'}>
            <Button  rightIcon={<MdFilterAlt/>} colorScheme={'grunt2'} size={size} onClick={onApplyFilter}>Filtriraj</Button>
            <Button colorScheme={'grunt2'} rightIcon={<MdCancel/>} variant={'outline'} size={size} onClick={onClose}>Odustani</Button>
        </ButtonGroup>
    </Box>
  )
}
